module.exports = __webpack_public_path__ + "static/media/astronaut.2f1befb2.png";